import React from "react";
import { useFormik } from "formik";
import Input from "components/input";
import DatePicker from "components/datePicker";
import Separator from "components/separator";
import Select from "components/select";
import { Row, Col } from "react-bootstrap";
import Button from "components/button";
import provinces from "lib/provinces";
import validator from "validator";
import { plateOptions } from "constants/plate";
import { companyOptions } from "constants/company";
const validate = (values) => {
  const errors = {};
  if (!values.company_type) {
    errors.company_type = "اجباری است";
  }
  if (!values.company_name) {
    errors.company_name = "اجباری است";
  }
  if (!values.company_national_code) {
    errors.company_national_code = "اجباری است";
  }
  if (
    values.company_national_code &&
    !validator.isNumeric(values.company_national_code)
  ) {
    errors.company_national_code = "کد ملی باید عدد باشد";
  }
  if (!values.company_commercial_code) {
    errors.company_commercial_code = "اجباری است";
  }
  if (!values.company_register_code) {
    errors.company_register_code = "اجباری است";
  }
  if (!values.company_letter_of_introduction_number) {
    errors.company_letter_of_introduction_number = "اجباری است";
  }
  if (!values.company_register_date) {
    errors.company_register_date = "اجباری است";
  }
  if (!values.company_register_province) {
    errors.company_register_province = "اجباری است";
  }
  if (!values.company_register_city) {
    errors.company_register_city = "اجباری است";
  }
  if (!values.company_letter_of_introduction_date) {
    errors.company_letter_of_introduction_date = "اجباری است";
  }
  if (!values.company_person_national_code) {
    errors.company_person_national_code = "اجباری است";
  }
  if (
    values.company_person_national_code &&
    !values.company_person_national_code.length === 10
  ) {
    errors.company_person_national_code = "کد ملی باید 10 رقم باشد";
  }
  if (!values.company_type_of_plate) {
    errors.company_type_of_plate = "اجباری است";
  }
  if (!values.address_province) {
    errors.address_province = "اجباری است";
  }
  if (!values.address_city) {
    errors.address_city = "اجباری است";
  }
  if (!values.address_primary_street) {
    errors.address_primary_street = "اجباری است";
  }
  if (!values.address_secondary_street) {
    errors.address_secondary_street = "اجباری است";
  }
  if (!values.address_alley) {
    errors.address_alley = "اجباری است";
  }
  if (!values.address_no) {
    errors.address_no = "اجباری است";
  }
  if (!values.address_postal_code) {
    errors.address_postal_code = "اجباری است";
  }
  if (
    values.address_postal_code &&
    !validator.isNumeric(values.address_postal_code)
  ) {
    errors.address_postal_code = "کد پستی باید عدد باشد";
  }
  if (!values.bank_sheba) {
    errors.bank_sheba = "اجباری است";
  }
  if (!values.bank_name) {
    errors.bank_name = "اجباری است";
  }
  if (!values.contact_phone) {
    errors.contact_phone = "اجباری است";
  }
  if (values.contact_phone && !validator.isNumeric(values.contact_phone)) {
    errors.contact_phone = "فقط عدد وارد کنید";
  }
  if (values.contact_email && !validator.isEmail(values.contact_email)) {
    errors.contact_email = "ایمیل صحیح نیست";
  }
  return errors;
};
const LegalForm = ({ onChange, loading, information }) => {
  const formik = useFormik({
    initialValues: {
      company_type: "",
      company_name: "",
      company_national_code: "",
      company_commercial_code: "",
      company_register_code: "",
      company_letter_of_introduction_number: "",
      company_register_province: "",
      company_register_city: "",
      company_letter_of_introduction_date: "",
      company_person_national_code: "",
      company_person_birthday: "",
      company_person_province: "",
      company_person_city: "",
      company_type_of_plate: "",
      address_province: "",
      address_city: "",
      address_primary_street: "",
      address_secondary_street: "",
      address_alley: "",
      address_no: "",
      address_postal_code: "",
      bank_sheba: "",
      bank_name: "",
      contact_phone: "",
      contact_email: "",
      ...information,
    },
    validate,
    onSubmit: (values) => onChange(values),
    validateOnChange: false,
  });
  const getCities = (id) => {
    let result = [];
    for (let i = 0; i < provinces.length; i++) {
      if (provinces[i].id === Number(id)) {
        result = provinces[i].cities;
        break;
      }
    }
    return result;
  };
  return (
    <form onSubmit={formik.handleSubmit}>
      <Separator title="اطلاعات مشتری" />
      <Row>
        <Col sm={12} md={3}>
          <div className="form-item">
            <Select
              name="company_type"
              onChange={formik.handleChange}
              value={formik.values.company_type}
              options={companyOptions}
              label="نوع شرکت:"
              error={formik.errors.company_type}
              required
            />
          </div>
        </Col>
        <Col sm={12} md={3}>
          <div className="form-item">
            <Input
              name="company_name"
              onChange={formik.handleChange}
              value={formik.values.company_name}
              label="نام شرکت:"
              error={formik.errors.company_name}
              required
            />
          </div>
        </Col>
        <Col sm={12} md={3}>
          <div className="form-item">
            <Input
              name="company_national_code"
              type="number"
              ltr
              onChange={formik.handleChange}
              value={formik.values.company_national_code}
              label="شناسه ملی :"
              error={formik.errors.company_national_code}
              required
            />
          </div>
        </Col>
        <Col sm={12} md={3}>
          <div className="form-item">
            <Input
              name="company_commercial_code"
              type="number"
              ltr
              onChange={formik.handleChange}
              value={formik.values.company_commercial_code}
              label="کد اقتصادی :"
              error={formik.errors.company_commercial_code}
              required
            />
          </div>
        </Col>
        <Col sm={12} md={4}>
          <div className="form-item">
            <Input
              name="company_register_code"
              type="number"
              ltr
              onChange={formik.handleChange}
              value={formik.values.company_register_code}
              label="شماره ثبت:"
              error={formik.errors.company_register_code}
              required
            />
          </div>
        </Col>
        <Col sm={12} md={4}>
          <div className="form-item">
            <Input
              name="company_letter_of_introduction_number"
              type="number"
              ltr
              onChange={formik.handleChange}
              value={formik.values.company_letter_of_introduction_number}
              label="شماره معرفی نامه:"
              error={formik.errors.company_letter_of_introduction_number}
              required
            />
          </div>
        </Col>
        <Col sm={12} md={4}>
          <div className="form-item">
            <DatePicker
              name="company_register_date"
              onChange={formik.handleChange}
              value={formik.values.company_register_date}
              label="تاریخ ثبت شرکت:"
              error={formik.errors.company_register_date}
              required
            />
          </div>
        </Col>
        <Col sm={12} md={3}>
          <div className="form-item">
            <Select
              name="company_register_province"
              onChange={(e) => {
                formik.handleChange(e);
                formik.setFieldValue("company_register_city", "", false);
              }}
              value={formik.values.company_register_province}
              options={provinces}
              label="استان ثبت شرکت:"
              error={formik.errors.company_register_province}
              required
            />
          </div>
        </Col>
        <Col sm={12} md={3}>
          <div className="form-item">
            <Select
              name="company_register_city"
              onChange={formik.handleChange}
              value={formik.values.company_register_city}
              options={getCities(formik.values.company_register_province)}
              label="شهر ثبت شرکت:"
              error={formik.errors.company_register_city}
              required
            />
          </div>
        </Col>
        <Col sm={12} md={3}>
          <div className="form-item">
            <DatePicker
              name="company_letter_of_introduction_date"
              onChange={formik.handleChange}
              value={formik.values.company_letter_of_introduction_date}
              label="تاریخ معرفی نامه:"
              error={formik.errors.company_letter_of_introduction_date}
              required
            />
          </div>
        </Col>
        <Col sm={12} md={3}>
          <div className="form-item">
            <Input
              name="company_person_national_code"
              type="number"
              ltr
              onChange={formik.handleChange}
              value={formik.values.company_person_national_code}
              label="کد ملی نماینده:"
              error={formik.errors.company_person_national_code}
              required
            />
          </div>
        </Col>
        
        <Col sm={12} md={3}>
          <div className="form-item">
            <Select
              name="company_type_of_plate"
              onChange={formik.handleChange}
              value={formik.values.company_type_of_plate}
              options={plateOptions}
              label="نوع پلاک درخواستی:"
              error={formik.errors.company_type_of_plate}
              required
            />
          </div>
        </Col>
      </Row>
      <Separator title="آدرس" />
      <Row>
        <Col sm={12} md={3}>
          <div className="form-item">
            <Select
              name="address_province"
              onChange={(e) => {
                formik.handleChange(e);
                formik.setFieldValue("address_city", "", false);
              }}
              value={formik.values.address_province}
              options={provinces}
              label="استان:"
              error={formik.errors.address_province}
              required
            />
          </div>
        </Col>
        <Col sm={12} md={3}>
          <div className="form-item">
            <Select
              name="address_city"
              onChange={formik.handleChange}
              value={formik.values.address_city}
              options={getCities(formik.values.address_province)}
              label="شهر:"
              error={formik.errors.address_city}
              required
            />
          </div>
        </Col>
        <Col sm={12} md={3}>
          <div className="form-item">
            <Input
              name="address_primary_street"
              onChange={formik.handleChange}
              value={formik.values.address_primary_street}
              label="خیابان اصلی:"
              error={formik.errors.address_primary_street}
              required
            />
          </div>
        </Col>
        <Col sm={12} md={3}>
          <div className="form-item">
            <Input
              name="address_secondary_street"
              onChange={formik.handleChange}
              value={formik.values.address_secondary_street}
              label="خیابان فرعی:"
              error={formik.errors.address_secondary_street}
              required
            />
          </div>
        </Col>
        <Col sm={12} md={4}>
          <div className="form-item">
            <Input
              name="address_alley"
              onChange={formik.handleChange}
              value={formik.values.address_alley}
              label="کوچه:"
              error={formik.errors.address_alley}
              required
            />
          </div>
        </Col>
        <Col sm={12} md={4}>
          <div className="form-item">
            <Input
              name="address_no"
              type="number"
              ltr
              onChange={formik.handleChange}
              value={formik.values.address_no}
              label="پلاک:"
              error={formik.errors.address_no}
              required
            />
          </div>
        </Col>
        <Col sm={12} md={4}>
          <div className="form-item">
            <Input
              name="address_postal_code"
              type="number"
              ltr
              onChange={formik.handleChange}
              value={formik.values.address_postal_code}
              label="کد پستی:"
              error={formik.errors.address_postal_code}
              required
            />
          </div>
        </Col>
      </Row>
      <Separator title="اطلاعات بانکی" />
      <Row>
        <Col sm={12} md={6}>
          <div className="form-item">
            <Input
              name="bank_sheba"
              type="number"
              ltr
              onChange={formik.handleChange}
              value={formik.values.bank_sheba}
              label="شماره شبا:"
              icon={<div className="icon">IR</div>}
              error={formik.errors.bank_sheba}
              required
            />
          </div>
        </Col>
        <Col sm={12} md={6}>
          <div className="form-item">
            <Input
              name="bank_name"
              onChange={formik.handleChange}
              value={formik.values.bank_name}
              label="نام بانک:"
              error={formik.errors.bank_name}
              required
            />
          </div>
        </Col>
      </Row>
      <Separator title="اطلاعات تماس" />
      <Row>
        <Col sm={12} md={6}>
          <div className="form-item">
            <Input
              name="contact_phone"
              onChange={formik.handleChange}
              value={formik.values.contact_phone}
              label="شماره ثابت:"
              type="number"
              ltr
              error={formik.errors.contact_phone}
              required
            />
          </div>
        </Col>
        <Col sm={12} md={6}>
          <div className="form-item">
            <Input
              name="contact_email"
              onChange={formik.handleChange}
              value={formik.values.contact_email}
              type="email"
              ltr
              label="ایمیل:"
              error={formik.errors.contact_email}
            />
          </div>
        </Col>
      </Row>
      <div className="buttons">
        <Button title="ثبت اطلاعات" type="submit" loading={loading} />
      </div>
    </form>
  );
};
export default LegalForm;
